import { ModeOfTransport } from "@iventis/domain-model/model/modeOfTransport";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import GeoJSON from "geojson";
import length from "@turf/length";
import along from "@turf/along";
import { feature } from "@turf/helpers";

export function setModeOfTransportIconName(modeOfTransport: ModeOfTransport) {
    let iconName: IconProp = "car";
    switch (modeOfTransport) {
        case ModeOfTransport.Cycle:
            iconName = "bicycle";
            break;
        case ModeOfTransport.Walk:
            iconName = "person-walking";
            break;
        case ModeOfTransport.Car:
        default:
            iconName = "car";
    }
    return iconName;
}

export function getMidPointOfLineString(lineString: GeoJSON.LineString) {
    // Get distance of line string
    const distanceOfLine = length(feature(lineString), { units: "meters" });
    // Find halfway distance along the line
    return along(lineString, distanceOfLine / 2, { units: "meters" });
}
